/*!
 * CSBone - photo-real engraved brass bone buckle, rendered as an inline SVG string.
 * Leatherius Woodman collar-set configurator. Dependency-free ES5.
 *
 *   var svg = CSBone.render({ lines:['Bella','206-386-7387'], font:'Straight'|'Cursive', size:'lg'|'sm', label:'...' });
 *   CSBone.onFontsReady(function(){ ...re-render... });   // optional
 *   CSBone.prepare();                                      // optional warm-up (builds the metal texture)
 *
 * Fonts: the workshop's laser fonts, declared on the page as
 *   @font-face{font-family:'LW Oregon';src:url(lw-oregon.woff2) format('woff2');font-display:swap}
 *   @font-face{font-family:'LW Brilliant';src:url(lw-brilliant.woff2) format('woff2');font-display:swap}
 * (Barlow / Ms Madi / system fonts are only fallbacks.)
 */
(function (win) {
  'use strict';

  // ---------------------------------------------------------------- geometry
  // Buckle measured from studio photos: 1.333 : 1 (4:3). Local units: 268 x 201.
  var BW = 268, BH = 201;
  // ViewBox adds a margin for the shadow, keeping the same 4:3 ratio.
  var PX = 14, PT = 7, VBW = 296, VBH = 222;

  // Left half of the silhouette (top-centre -> around the left end -> bottom-centre),
  // traced from a straight-on photo, de-rotated, mirrored and smoothed.
  var HALF = [[135, 42.26], [120.91, 42.21], [107.2, 40.35], [95.98, 32.1], [87.4, 21.16], [78, 10.94], [65.91, 4.05],
    [52.65, 0.13], [38.72, 0.55], [23.6, 3.6], [14.2, 12.2], [7.2, 24.5], [4.53, 39.45], [3.63, 53.37], [3.93, 67.31],
    [6.06, 81.1], [11.02, 94.09], [12.32, 106.7], [6.64, 119.41], [3.73, 133.05], [0.3, 146.4], [2.59, 160.09],
    [4.8, 174.5], [11.8, 186.6], [21.6, 195.6], [36.71, 199.61], [50.66, 199.87], [64.17, 196.78], [76.62, 190.68],
    [86.41, 180.82], [95.02, 169.88], [107.26, 163.47], [121.18, 162.78], [135, 162.77]];

  // Notch levels (top/bottom of the shaft) - the engraving has to stay between them.
  var SHAFT_TOP = 42.2, SHAFT_BOT = 162.8;

  function buildOutline() {
    var pts = [], i, p;
    for (i = 0; i < HALF.length; i++) pts.push(HALF[i]);
    for (i = HALF.length - 2; i >= 1; i--) { p = HALF[i]; pts.push([BW - p[0], p[1]]); }
    // normalise the bbox to exactly 0..BW x 0..BH
    var x0 = 1e9, x1 = -1e9, y0 = 1e9, y1 = -1e9;
    for (i = 0; i < pts.length; i++) { p = pts[i]; x0 = Math.min(x0, p[0]); x1 = Math.max(x1, p[0]); y0 = Math.min(y0, p[1]); y1 = Math.max(y1, p[1]); }
    var sx = BW / (x1 - x0), sy = BH / (y1 - y0);
    for (i = 0; i < pts.length; i++) { p = pts[i]; pts[i] = [(p[0] - x0) * sx, (p[1] - y0) * sy]; }
    SHAFT_TOP = (SHAFT_TOP - y0) * sy; SHAFT_BOT = (SHAFT_BOT - y0) * sy;
    return pts;
  }
  var OUTLINE = buildOutline();

  // closed Catmull-Rom spline -> cubic Bezier path
  function pathFrom(pts, ox, oy) {
    var n = pts.length, d = '', i, p0, p1, p2, p3, k = 1 / 6;
    function f(v) { return (Math.round(v * 100) / 100).toString(); }
    d = 'M' + f(pts[0][0] + ox) + ' ' + f(pts[0][1] + oy);
    for (i = 0; i < n; i++) {
      p0 = pts[(i - 1 + n) % n]; p1 = pts[i]; p2 = pts[(i + 1) % n]; p3 = pts[(i + 2) % n];
      d += 'C' + f(p1[0] + (p2[0] - p0[0]) * k + ox) + ' ' + f(p1[1] + (p2[1] - p0[1]) * k + oy) + ' ' +
        f(p2[0] - (p3[0] - p1[0]) * k + ox) + ' ' + f(p2[1] - (p3[1] - p1[1]) * k + oy) + ' ' +
        f(p2[0] + ox) + ' ' + f(p2[1] + oy);
    }
    return d + 'Z';
  }
  var PATH_LOCAL = pathFrom(OUTLINE, 0, 0);
  var PATH = pathFrom(OUTLINE, PX, PT);

  // ---------------------------------------------------------------- font metrics
  // Advance widths and glyph ink bounds per 1000 em for ASCII 32..126, extracted with fontTools from
  // lw-oregon.woff2 (OR) and lw-brilliant.woff2 (BR). Used until the web fonts have loaded, so the
  // layout is already right before the fonts swap in. Keys: a advance, u/d ink top/bottom,
  // l ink overhang left of the origin, r ink overhang right of the advance.
  var MET={"OR":{"a":[200,235,381,700,546,768,540,244,286,286,369,435,244,320,244,360,568,323,551,540,565,540,568,490,575,568,244,244,298,435,298,495,820,600,561,538,568,520,520,570,581,240,510,573,520,666,583,568,554,568,550,530,510,580,600,800,580,580,540,350,360,350,350,435,500,600,561,539,568,520,520,570,581,240,510,573,530,666,583,568,554,568,550,530,510,580,600,800,580,580,540,500,240,500,500],"u":[0,721,721,720,825,720,822,720,757,757,720,520,120,414,120,720,728,719,726,728,719,719,720,719,727,729,423,422,474,503,473,728,729,719,720,726,720,718,719,727,719,719,718,719,719,720,720,728,720,729,720,729,719,719,719,720,720,720,719,719,720,720,719,111,700,719,720,726,720,718,719,727,719,719,718,719,719,720,720,728,720,729,720,729,719,719,719,720,720,720,719,700,739,700,700],"d":[0,2,-522,0,97,-1,100,-521,37,37,-465,-200,79,-304,-1,0,9,0,-1,9,0,7,11,0,11,1,-1,80,-245,-217,-245,3,8,0,0,12,0,0,0,11,0,0,10,0,0,0,0,9,-1,116,0,10,0,9,0,-1,-1,0,0,0,0,-1,-550,0,0,0,0,12,0,0,0,11,0,0,10,0,0,0,0,9,-1,116,0,10,0,9,0,-1,-1,0,0,0,20,0,0],"l":[0,-58,-46,-30,-53,-48,-54,-48,-65,-52,-65,-57,-48,-52,-65,-47,-53,-51,-65,-54,-57,-58,-53,-55,-50,-52,-65,-48,-64,-78,-64,-45,-42,-48,-55,-51,-64,-63,-63,-54,-65,-65,-50,-65,-63,-64,-60,-53,-61,-53,-60,-45,-53,-59,-48,-50,-45,-43,-60,-67,-47,-67,-53,-57,0,-48,-55,-52,-64,-63,-63,-54,-65,-65,-50,-65,-63,-64,-60,-53,-61,-53,-60,-45,-53,-59,-48,-50,-45,-43,-60,0,-65,0,0],"r":[-200,-58,-64,-30,-53,-48,-54,-66,-52,-65,-65,-57,-66,-52,-65,-47,-53,-69,-65,-54,-57,-50,-52,-55,-50,-52,-65,-66,-64,-78,-64,-45,-42,-48,-46,-52,-52,-53,-53,-54,-65,-65,-63,-47,-53,-64,-60,-53,-53,-53,-48,-45,-53,-59,-48,-50,-45,-43,-60,-67,-47,-67,-69,-57,0,-48,-46,-53,-52,-53,-53,-54,-65,-65,-63,-47,-63,-64,-60,-53,-53,-53,-48,-45,-53,-59,-48,-50,-45,-43,-60,0,-65,0,0],"cap":720},"BR":{"a":[180,228,127,424,427,499,439,80,231,212,185,382,97,382,111,203,394,206,440,403,391,409,391,336,385,380,176,176,266,382,266,325,628,542,601,464,618,451,369,447,492,279,271,459,445,816,589,471,455,491,539,495,382,574,503,799,634,478,527,291,267,279,409,443,139,361,392,243,417,243,245,343,426,208,177,365,256,627,421,311,397,384,259,206,244,395,339,544,449,348,342,291,227,314,395],"u":[0,734,444,352,727,630,579,440,812,811,416,362,66,231,66,743,634,635,634,636,634,657,634,638,633,635,308,308,317,290,316,740,414,709,718,715,718,715,718,718,718,718,719,718,718,742,718,724,718,724,718,728,718,709,757,834,713,718,718,820,743,819,260,0,431,327,739,365,738,338,654,327,739,474,470,739,738,399,388,397,320,327,452,383,597,327,437,437,331,327,330,832,807,845,195],"d":[0,0,-331,40,67,35,126,-327,71,72,-300,-68,47,-186,0,56,11,5,3,5,2,0,7,0,4,6,-28,19,-6,-127,-5,0,125,181,139,40,137,42,67,249,183,62,196,195,62,190,180,30,17,179,195,47,67,182,78,78,69,252,55,81,56,82,-69,23,-349,42,68,16,85,16,258,408,125,-25,410,74,84,33,91,-22,411,408,43,47,61,74,17,16,36,408,344,91,68,78,-132],"l":[0,-92,39,-55,-41,-48,-50,32,-67,6,-30,-55,-13,-56,-28,-52,1,0,0,-1,0,-1,8,-3,2,10,-62,-61,-30,-56,-32,-36,-67,-15,-20,-40,-20,-30,-13,-74,-20,-20,20,-20,-21,-20,-20,-50,0,-50,-20,-47,-26,-20,-20,-20,5,0,0,-99,-52,-43,-45,-34,-15,-1,-1,0,-1,0,15,18,-1,-17,180,-1,-10,11,9,-12,165,0,3,30,40,-9,-12,-12,-16,9,29,-84,-102,-34,-72],"r":[-180,-14,-37,-35,-30,-75,-51,-51,35,-19,-31,-35,-23,-36,-26,11,-29,-17,-5,-17,-6,-19,-23,3,-16,-14,-50,-50,-28,-35,-26,26,-58,71,0,-31,0,-30,179,-4,97,-10,-9,87,-16,70,70,0,99,0,49,1,179,51,43,58,87,43,102,-10,-53,-54,-44,-47,-40,32,35,32,40,32,34,34,32,33,36,32,32,32,33,34,34,34,32,34,32,33,34,34,32,35,34,37,-88,-36,-48],"cap":723}};

  // Oregon (Marco van Luijn) for Straight and for every phone line, Brilliant (Unicode Studio) for
  // the Cursive name - both single Regular weights, as the laser uses them.
  var FONT_SANS = "'LW Oregon',Barlow,'DM Sans','Helvetica Neue',Arial,sans-serif";
  var FONT_SCRIPT = "'LW Brilliant','Ms Madi','Great Vibes','Brush Script MT',cursive";
  var FACE_SANS = '400 100px "LW Oregon"', FACE_SCRIPT = '400 100px "LW Brilliant"';

  function baseChar(ch) {
    if (ch.normalize) { var b = ch.normalize('NFD').charAt(0); if (b) return b; }
    return ch;
  }
  function tableMeasure(T, s) {
    var adv = 0, up = 0, dn = 0, i, c, l = 0, r = 0;
    for (i = 0; i < s.length; i++) {
      c = s.charCodeAt(i);
      if (c < 32 || c > 126) { c = baseChar(s.charAt(i)).charCodeAt(0); if (c < 32 || c > 126) c = 110; /* 'n' */ }
      c -= 32;
      if (i === 0) l = T.l[c];
      if (i === s.length - 1) r = T.r[c];
      adv += T.a[c]; up = Math.max(up, T.u[c]); dn = Math.max(dn, T.d[c]);
      if (s.charCodeAt(i) > 126 && /[A-Z]/.test(baseChar(s.charAt(i)))) up = Math.max(up, T.cap + 180); // accented caps
    }
    return { w: adv / 1000, left: l / 1000, right: r / 1000, up: up / 1000, dn: dn / 1000 };
  }

  var mctx = null, mcache = {}, mcount = 0;
  function fontReady(face) {
    try { return !!(win.document && document.fonts && document.fonts.check(face)); } catch (e) { return false; }
  }
  // returns metrics in em: w = advance width, ink extents left/right/up/dn
  function measure(kind, s) {
    var key = kind + '|' + s;
    if (mcache[key]) return mcache[key];
    var T = kind === 'script' ? MET.BR : MET.OR, face = kind === 'script' ? FACE_SCRIPT : FACE_SANS;
    var m = tableMeasure(T, s);
    if (fontReady(face)) {
      try {
        if (!mctx) mctx = document.createElement('canvas').getContext('2d');
        mctx.font = face;
        var r = mctx.measureText(s);
        if (r && r.width > 0) {
          m.w = r.width / 100;
          if (r.actualBoundingBoxAscent != null) {
            m.left = r.actualBoundingBoxLeft / 100;
            m.right = (r.actualBoundingBoxRight - r.width) / 100;
            m.up = r.actualBoundingBoxAscent / 100; m.dn = r.actualBoundingBoxDescent / 100;
          }
        }
      } catch (e) { }
    }
    if (++mcount > 400) { mcache = {}; mcount = 0; }
    mcache[key] = m;
    return m;
  }

  // ---------------------------------------------------------------- metal texture (built once)
  var ASSETS = null;

  function rng(seed) {
    var s = seed >>> 0;
    return function () { s = (s + 0x6D2B79F5) >>> 0; var t = s; t = Math.imul(t ^ (t >>> 15), t | 1); t ^= t + Math.imul(t ^ (t >>> 7), t | 61); return ((t ^ (t >>> 14)) >>> 0) / 4294967296; };
  }
  if (!Math.imul) Math.imul = function (a, b) { var ah = (a >>> 16) & 0xffff, al = a & 0xffff, bh = (b >>> 16) & 0xffff, bl = b & 0xffff; return ((al * bl) + (((ah * bl + al * bh) << 16) >>> 0) | 0); };

  // separable running-sum box blur, in place; three passes approximate a Gaussian
  function boxBlur(src, w, h, r, tmp, acc) {
    var x, y, a, inv = 1 / (2 * r + 1), row, lo, hi;
    for (y = 0; y < h; y++) {
      row = y * w; a = 0;
      for (x = -r; x <= r; x++) a += src[row + (x < 0 ? 0 : x > w - 1 ? w - 1 : x)];
      for (x = 0; x < w; x++) {
        tmp[row + x] = a * inv;
        hi = x + r + 1; lo = x - r;
        a += src[row + (hi > w - 1 ? w - 1 : hi)] - src[row + (lo < 0 ? 0 : lo)];
      }
    }
    for (x = 0; x < w; x++) acc[x] = 0;
    for (y = -r; y <= r; y++) { row = (y < 0 ? 0 : y > h - 1 ? h - 1 : y) * w; for (x = 0; x < w; x++) acc[x] += tmp[row + x]; }
    for (y = 0; y < h; y++) {
      row = y * w; hi = (y + r + 1 > h - 1 ? h - 1 : y + r + 1) * w; lo = (y - r < 0 ? 0 : y - r) * w;
      for (x = 0; x < w; x++) { src[row + x] = acc[x] * inv; acc[x] += tmp[hi + x] - tmp[lo + x]; }
    }
  }

  // Antique-brass colour ramp, sampled from the product photos (intensity -> sRGB)
  var RAMP = [
    [0.00, 40, 30, 20], [0.20, 84, 66, 48], [0.35, 120, 94, 68], [0.47, 141, 115, 86], [0.58, 161, 136, 104],
    [0.68, 179, 154, 122], [0.78, 197, 173, 141], [0.88, 217, 194, 163], [0.98, 234, 214, 186],
    [1.08, 246, 231, 206], [1.20, 254, 247, 233]];
  function ramp(I, out) {
    if (I <= RAMP[0][0]) { out[0] = RAMP[0][1]; out[1] = RAMP[0][2]; out[2] = RAMP[0][3]; return; }
    for (var j = 1; j < RAMP.length; j++) {
      if (I <= RAMP[j][0] || j === RAMP.length - 1) {
        var a = RAMP[j - 1], b = RAMP[j], t = Math.min(1, (I - a[0]) / (b[0] - a[0]));
        out[0] = a[1] + (b[1] - a[1]) * t; out[1] = a[2] + (b[2] - a[2]) * t; out[2] = a[3] + (b[3] - a[3]) * t; return;
      }
    }
  }

  function g2(x, s) { x /= s; return Math.exp(-x * x); }

  // Brushed face under a studio softbox: brushing runs horizontally, so reflections smear
  // into soft vertical bands. Bright upper-left lobe, darker middle, a strip light on the right.
  // Returned as separable parts: I(u,v) = U[x] + V[y] + U2[x]*V2[y]
  function faceU(u) {
    return 0.40 * g2(u - 0.015, 0.095) + 0.07 * g2(u - 0.20, 0.20)     // softbox band on the left lobes
      - 0.22 * g2(u - 0.60, 0.21)                                     // dark room reflected in the middle
      + 0.24 * g2(u - 0.935, 0.055) + 0.06 * g2(u - 0.84, 0.12)       // strip light on the right lobes
      + 0.03 * g2(u - 0.36, 0.035) - 0.025 * g2(u - 0.73, 0.04);      // faint secondary streak bands
  }
  function faceV(v) { return 0.57 + 0.20 * (0.5 - v); }
  function faceU2(u) { return g2(u - 0.05, 0.16); }
  function faceV2(v) { return 0.10 * (0.4 - v); }

  function toBlobURL(cv, type, q) {
    var url = cv.toDataURL(type, q);
    try {
      if (win.Blob && win.URL && URL.createObjectURL && win.atob) {
        var b64 = url.slice(url.indexOf(',') + 1), bin = atob(b64), n = bin.length, u8 = new Uint8Array(n);
        for (var i = 0; i < n; i++) u8[i] = bin.charCodeAt(i);
        return URL.createObjectURL(new Blob([u8], { type: type }));
      }
    } catch (e) { }
    return url;
  }

  var BODY_S = 3.0, BODY_M = 2;   // px per unit, margin (units) around the buckle in the body image
  var BEVEL = 6;                 // rounded-edge width (units)

  function ctx2d(cv) {
    try { return cv.getContext('2d', { willReadFrequently: true }) || cv.getContext('2d'); } catch (e) { return cv.getContext('2d'); }
  }

  function buildAssets() {
    if (ASSETS) return ASSETS;
    ASSETS = { ok: false };
    var t0 = now();
    try {
      if (!win.document || typeof Path2D === 'undefined' || typeof Float32Array === 'undefined') return ASSETS;
      var cv = document.createElement('canvas');
      if (!cv.getContext) return ASSETS;
      var S = BODY_S, M = BODY_M;
      var w = Math.round((BW + 2 * M) * S), h = Math.round((BH + 2 * M) * S), N = w * h, i, x, y;
      cv.width = w; cv.height = h;
      var cx = ctx2d(cv), shape = new Path2D(PATH_LOCAL);

      // Height field of the rounded edge: the silhouette blurred to the bevel width (computed at half
      // resolution, sampled bilinearly). m = 0.5 on the outline, ~1 on the flat face; its gradient
      // gives the direction the edge faces.
      var hw = Math.ceil(w / 2) + 1, hh = Math.ceil(h / 2) + 1, HN = hw * hh;
      cx.setTransform(S / 2, 0, 0, S / 2, M * S / 2, M * S / 2);
      cx.fill(shape);
      var a = cx.getImageData(0, 0, hw, hh).data, T = [now()];
      var m = new Float32Array(HN), tmp = new Float32Array(HN), acc = new Float32Array(hw);
      for (i = 0; i < HN; i++) m[i] = a[i * 4 + 3] / 255;
      var br = Math.max(1, Math.round(BEVEL * S / 4.2));
      boxBlur(m, hw, hh, br, tmp, acc); boxBlur(m, hw, hh, br, tmp, acc); boxBlur(m, hw, hh, br, tmp, acc);
      cx.setTransform(1, 0, 0, 1, 0, 0); cx.clearRect(0, 0, w, h);
      T.push(now());

      var FU = new Float32Array(w), FU2 = new Float32Array(w), FV = new Float32Array(h), FV2 = new Float32Array(h);
      for (x = 0; x < w; x++) { FU[x] = faceU((x / S - M) / BW); FU2[x] = faceU2((x / S - M) / BW); }
      for (y = 0; y < h; y++) { FV[y] = faceV((y / S - M) / BH); FV2[y] = faceV2((y / S - M) / BH); }

      // brushed grain: per-row offset + slow and fast value noise along the row (inline below)
      // plus scattered scratches (sparse, written into tex)
      var R = rng(20261022), tex = new Float32Array(N), kk, gap1 = 22, gap2 = 5, prev = 0;
      var nk1 = Math.ceil(w / gap1) + 2, nk2 = Math.ceil(w / gap2) + 2, k1 = new Float32Array(nk1), k2 = new Float32Array(nk2);
      var gauss = function () { var u1 = R() || 1e-9, u2 = R(); return Math.sqrt(-2 * Math.log(u1)) * Math.cos(6.2832 * u2); };
      for (kk = 0; kk < 140; kk++) {
        var sy0 = R() * h, sx0 = R() * w, len = 20 + R() * R() * 260, ang = (R() - 0.5) * (R() < 0.12 ? 0.5 : 0.03),
          amp = (R() < 0.6 ? 1 : -1) * (0.03 + R() * 0.06), s;
        for (s = 0; s < len; s++) {
          x = Math.round(sx0 + s); y = Math.round(sy0 + s * ang);
          if (x < 0 || x >= w || y < 0 || y >= h) continue;
          tex[y * w + x] += amp * Math.sin(3.1416 * s / len);
        }
      }
      // colour lookup table over the intensity range
      var LUTN = 1024, L0 = -0.3, L1 = 1.5, lr = new Uint8ClampedArray(LUTN), lg = new Uint8ClampedArray(LUTN), lb = new Uint8ClampedArray(LUTN), col = [0, 0, 0];
      for (kk = 0; kk < LUTN; kk++) { ramp(L0 + (L1 - L0) * kk / (LUTN - 1), col); lr[kk] = col[0]; lg[kk] = col[1]; lb[kk] = col[2]; }
      var lsc = (LUTN - 1) / (L1 - L0);
      T.push(now());

      // shading
      // - thin dark line at the very edge (the side wall turning away)
      // - specular crest on the edges that face the key light (upper left)
      // - the roll darkens towards the edge on the sides turned away from it
      var out = cx.createImageData(w, h), od = out.data;
      var LX = -0.45, LY = -0.89, ig1 = 1 / gap1, ig2 = 1 / gap2;
      // edge profile tables over t in [0,1]: specular crest, dark outer line, roll^1.5
      var PN = 256, PC = new Float32Array(PN + 1), PE = new Float32Array(PN + 1), PR = new Float32Array(PN + 1);
      for (kk = 0; kk <= PN; kk++) { var tt = kk / PN; PC[kk] = g2(tt - 0.36, 0.24); PE[kk] = g2(tt, 0.15); PR[kk] = Math.pow(1 - tt, 1.5); }
      var oc = lr[0], hy, iy, ty, row0, row1;
      for (y = 0; y < h; y++) {
        var rv = 0.45 * prev + 0.55 * gauss() * 0.040; prev = rv;
        for (kk = 0; kk < nk1; kk++) k1[kk] = gauss() * 0.030;
        for (kk = 0; kk < nk2; kk++) k2[kk] = gauss() * 0.026;
        var off1 = R() * gap1, off2 = R() * gap2, fv = FV[y], fv2 = FV2[y];
        hy = y * 0.5; iy = hy | 0; ty = hy - iy; row0 = iy * hw; row1 = row0 + hw;
        for (x = 0; x < w; x++) {
          i = y * w + x;
          var o4 = i * 4;
          // bilinear sample of the half-res height field
          var hx = x * 0.5, ix = hx | 0, tx = hx - ix;
          var m00 = m[row0 + ix], m10 = m[row0 + ix + 1], m01 = m[row1 + ix], m11 = m[row1 + ix + 1];
          var mv = (m00 + (m10 - m00) * tx) * (1 - ty) + (m01 + (m11 - m01) * tx) * ty;
          if (mv < 0.06) { od[o4] = oc; od[o4 + 1] = oc; od[o4 + 2] = oc; od[o4 + 3] = 255; continue; } // far outside: clipped away
          var p1 = (x + off1) * ig1, i1 = p1 | 0, f1 = p1 - i1; f1 = f1 * f1 * (3 - 2 * f1);
          var p2 = (x + off2) * ig2, i2 = p2 | 0, f2 = p2 - i2;
          var grain = rv + k1[i1] + (k1[i1 + 1] - k1[i1]) * f1 + k2[i2] + (k2[i2 + 1] - k2[i2]) * f2 + tex[i];
          var I = FU[x] + fv + FU2[x] * fv2, nz = 1;
          if (mv < 0.985) {
            var t = (mv - 0.5) / 0.485; if (t < 0) t = 0;
            var gx = (m00 - m10) * (1 - ty) + (m01 - m11) * ty, gy = (m00 - m01) * (1 - tx) + (m10 - m11) * tx;
            var gl = Math.sqrt(gx * gx + gy * gy) || 1;
            var face = (gx * LX + gy * LY) / gl;
            var up = face > 0 ? face : 0, dn = face < 0 ? -face : 0, up15 = up * Math.sqrt(up);
            var pk = (t * PN) | 0, roll = 1 - t;
            I += PC[pk] * (0.05 + 0.46 * up15) - PE[pk] * (0.38 + 0.12 * dn - 0.1 * up) + roll * (0.08 * up) - PR[pk] * 0.24 * dn;
            nz = 0.4 + 0.6 * t;
          }
          I *= 1 + grain * nz;
          var li = ((I - L0) * lsc) | 0; li = li < 0 ? 0 : li > LUTN - 1 ? LUTN - 1 : li;
          od[o4] = lr[li]; od[o4 + 1] = lg[li]; od[o4 + 2] = lb[li]; od[o4 + 3] = 255;
        }
      }
      cx.setTransform(1, 0, 0, 1, 0, 0);
      T.push(now());
      cx.putImageData(out, 0, 0);
      var bodyURL = toBlobURL(cv, 'image/jpeg', 0.9);
      T.push(now());

      // soft ambient shadow (whole viewBox, low-res alpha); the contact line is drawn as vector
      var SS = 1, sw = Math.round(VBW * SS), sh = Math.round(VBH * SS), SN = sw * sh;
      var scv = document.createElement('canvas'); scv.width = sw; scv.height = sh;
      var sc = ctx2d(scv);
      sc.setTransform(SS, 0, 0, SS, PX * SS, (PT + 3.4) * SS); sc.fill(shape);
      var sa = sc.getImageData(0, 0, sw, sh).data, A1 = new Float32Array(SN), stmp = new Float32Array(SN), sacc = new Float32Array(sw);
      for (i = 0; i < SN; i++) A1[i] = sa[i * 4 + 3] / 255;
      var rr = Math.max(1, Math.round(2.4 * SS));
      boxBlur(A1, sw, sh, rr, stmp, sacc); boxBlur(A1, sw, sh, rr, stmp, sacc); boxBlur(A1, sw, sh, rr, stmp, sacc);
      var simg = sc.createImageData(sw, sh), sdd = simg.data;
      for (i = 0; i < SN; i++) { sdd[i * 4] = 58; sdd[i * 4 + 1] = 40; sdd[i * 4 + 2] = 24; sdd[i * 4 + 3] = Math.round(A1[i] * 0.36 * 255); }
      sc.setTransform(1, 0, 0, 1, 0, 0); sc.putImageData(simg, 0, 0);
      var shadowURL = toBlobURL(scv, 'image/png');
      T.push(now());

      var st = [r1(T[0] - t0)]; for (i = 1; i < T.length; i++) st.push(r1(T[i] - T[i - 1]));
      // stages (ms): mask, edge blur, grain+lut, shading, jpeg, shadow
      ASSETS = { ok: true, body: bodyURL, shadow: shadowURL, ms: r1(now() - t0), stages: st, w: w, h: h };
    } catch (e) {
      ASSETS = { ok: false, err: String(e) };
    }
    return ASSETS;
  }

  function r1(v) { return Math.round(v * 10) / 10; }
  function now() { return (win.performance && performance.now) ? performance.now() : +new Date(); }

  // ---------------------------------------------------------------- text layout
  // Measured on the real engravings (straight-on photos of JINGLE / JOY / Bella / Noel), H = buckle
  // height, W = width:
  //   - the name is set horizontally stretched: ink width / height is 1.22-1.28x the font's own
  //     (JINGLE 1.24, JOY 1.22, Bella 1.23-1.30) - the workshop template widens the name;
  //   - Oregon capitals of the name 0.20H; Brilliant capitals 0.24-0.25H;
  //   - phone lines are Oregon in both modes, digits ~0.11-0.12H, ~0.72W wide;
  //   - name baseline to phone top ~0.44 of the phone digit height; block centred a touch below the shaft.
  var CAP_SANS = MET.OR.cap / 1000;          // Oregon cap height (em) = 0.72
  var CAP_SCRIPT = MET.BR.cap / 1000;        // Brilliant capital height (em) = 0.723
  var NAME_SX = 1.23;                        // horizontal stretch of the name line
  var PHONE_SX = 0.92, PHONE_TRACK = 0.05;   // phone lines: Oregon slightly condensed, set a little open
  var MAXW_NAME = 0.75 * BW, MAXW_LINE = 0.72 * BW;
  var SAFE_TOP = SHAFT_TOP + 8, SAFE_BOT = SHAFT_BOT - 8;

  function layout(lines, cursive) {
    var L = [], i, s, n = lines.length;
    for (i = 0; i < n; i++) {
      s = lines[i];
      var isName = i === 0, script = isName && cursive;
      var kind = script ? 'script' : 'sans';
      var m = measure(kind, s);
      var cap, fs, sx, up, dn, wEm;
      if (isName) cap = n === 1 ? (script ? 0.29 : 0.24) * BH : (script ? 0.245 : 0.20) * BH;
      else cap = 0.113 * BH;
      fs = cap / (script ? CAP_SCRIPT : CAP_SANS);
      sx = isName ? NAME_SX : PHONE_SX;
      var track = isName ? 0 : PHONE_TRACK;
      wEm = m.w + m.left + m.right + track * Math.max(0, s.length - 1);   // ink width at 1em, unstretched
      var maxW = isName ? MAXW_NAME : MAXW_LINE;
      if (wEm * fs * sx > maxW) {
        // long name: give up the template stretch first (down to none), then shrink the size
        if (isName) sx = Math.max(1, maxW / (wEm * fs));
        if (wEm * fs * sx > maxW) fs = maxW / (wEm * sx);
      }
      up = Math.max(m.up, script ? CAP_SCRIPT : CAP_SANS);
      dn = m.dn;
      L.push({ s: s, kind: kind, fs: fs, sx: sx, track: track, m: m, up: up, dn: dn, name: isName, script: script });
    }
    // name stays dominant: secondary lines never taller than 82% (72% with three lines) of its capitals
    var nameCap = L[0].fs * (L[0].script ? CAP_SCRIPT / 1.15 : CAP_SANS);
    for (i = 1; i < L.length; i++) {
      var lim = (L.length > 2 ? 0.72 : 0.82) * nameCap / CAP_SANS;
      if (L[i].fs > lim) L[i].fs = lim;
    }
    // vertical stack (units)
    // descender room: a script name's loops may tuck a little into the gap, sans descenders count fully
    function dnUse(it, last) { return last ? it.dn * 0.5 : it.script ? it.dn * 0.75 : it.dn; }
    function gapAfter(j) { var nx = L[j + 1]; return (L.length > 2 ? 0.40 : 0.46) * nx.fs * CAP_SANS; }
    function blockH() {
      var hgt = 0;
      for (var j = 0; j < L.length; j++) {
        hgt += (L[j].up + dnUse(L[j], j === L.length - 1)) * L[j].fs;
        if (j < L.length - 1) hgt += gapAfter(j);
      }
      return hgt;
    }
    // the real engraving keeps a generous margin; a third line shrinks the whole block
    var avail = Math.min(SAFE_BOT - SAFE_TOP, (L.length > 2 ? 0.465 : 0.52) * BH), bh = blockH();
    if (bh > avail) { var k = avail / bh; for (i = 0; i < L.length; i++) L[i].fs *= k; bh = blockH(); }
    // place baselines
    var cy = (SHAFT_TOP + SHAFT_BOT) / 2 + 4, y = cy - bh / 2;
    for (i = 0; i < L.length; i++) {
      var it2 = L[i];
      y += it2.up * it2.fs;
      it2.base = y;
      y += dnUse(it2, i === L.length - 1) * it2.fs;
      if (i < L.length - 1) y += gapAfter(i);
    }
    return L;
  }

  // ---------------------------------------------------------------- SVG
  function esc(s) { return String(s).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;'); }
  function r2(v) { return Math.round(v * 100) / 100; }
  var UID = 0, PFX = 'csb' + Math.floor(Math.random() * 1e6).toString(36);

  // engraving colours: laser-frosted metal is pale and matte
  var ENG_FILL = '#ecdcc0', ENG_EDGE = '#5b432c';

  function textEl(it, cx, extra) {
    var fam = it.script ? FONT_SCRIPT : FONT_SANS;
    var a = ' x="' + r2(cx) + '" y="' + r2(it.base) + '" font-family="' + fam + '" font-weight="400" font-size="' + r2(it.fs) + '" text-anchor="middle"';
    // Oregon lines: pin the run length to the measured advance, so the fit holds even while a
    // fallback font is showing (spacing absorbs the difference). Not for the joined-up script.
    if (!it.script && it.s.length > 1) a += ' textLength="' + r2((it.m.w + it.track * (it.s.length - 1)) * it.fs) + '" lengthAdjust="spacing"';
    if (it.sx !== 1) a += ' transform="matrix(' + Math.round(it.sx * 1000) / 1000 + ' 0 0 1 ' + r2(cx * (1 - it.sx)) + ' 0)"';
    return '<text' + a + (extra || '') + '>' + esc(it.s) + '</text>';
  }

  function render(opts) {
    opts = opts || {};
    var cursive = opts.font === 'Cursive';
    var raw = opts.lines == null ? [] : typeof opts.lines === 'string' ? [opts.lines] : opts.lines, lines = [], i, s;
    for (i = 0; i < 3; i++) {
      s = raw[i] == null ? '' : String(raw[i]).replace(/\s+/g, ' ').replace(/^\s+|\s+$/g, '');
      if (i === 0 && !s) s = cursive ? 'Bella' : 'BELLA';
      if (!cursive) s = s.toUpperCase();
      if (s) lines.push(s);
    }
    var A = buildAssets();
    var id = PFX + (++UID), small = opts.size === 'sm';
    var L = layout(lines, cursive);
    var label = opts.label || ('Engraving preview: ' + lines.join(', '));
    var cx = PX + BW / 2;

    var h = '<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" class="cs-bone' + (small ? ' cs-bone-s' : '') + '" viewBox="0 0 ' + VBW + ' ' + VBH + '" role="img" aria-label="' + esc(label) + '">';
    h += '<title>' + esc(label) + '</title><defs><clipPath id="' + id + 'c"><path d="' + PATH + '"/></clipPath>';
    if (!A.ok) {
      h += '<linearGradient id="' + id + 'g" x1="0" y1="0" x2=".35" y2="1"><stop offset="0" stop-color="#e2cfb2"/><stop offset=".45" stop-color="#b3957a"/><stop offset="1" stop-color="#8a6c52"/></linearGradient>';
    }
    h += '</defs>';
    if (A.ok) {
      h += '<image href="' + A.shadow + '" xlink:href="' + A.shadow + '" x="0" y="0" width="' + VBW + '" height="' + VBH + '" preserveAspectRatio="none"/>';
      h += '<path d="' + PATH + '" fill="#2e2014" opacity=".3" transform="translate(0 .9)"/>';
      h += '<g clip-path="url(#' + id + 'c)"><image href="' + A.body + '" xlink:href="' + A.body + '" x="' + (PX - BODY_M) + '" y="' + (PT - BODY_M) + '" width="' + (BW + 2 * BODY_M) + '" height="' + (BH + 2 * BODY_M) + '" preserveAspectRatio="none"/></g>';
    } else {
      h += '<path d="' + PATH + '" fill="#3a2818" opacity=".25" transform="translate(0 3)"/>';
      h += '<path d="' + PATH + '" fill="url(#' + id + 'g)"/>';
    }
    h += '<path d="' + PATH + '" fill="none" stroke="#3b2a1a" stroke-opacity=".3" stroke-width=".5"/>';

    // engraving
    h += '<g transform="translate(' + PX + ' ' + PT + ')">';
    var ox = BW / 2;
    // faint dark lip under the frosted mark (gives the hair of depth a laser leaves)
    h += '<g fill="' + ENG_EDGE + '" opacity=".22" transform="translate(0 .45)">';
    for (i = 0; i < L.length; i++) h += textEl(L[i], ox, '');
    h += '</g><g fill="' + ENG_FILL + '" fill-opacity=".95">';
    // a faint half-transparent fringe reads as the soft edge of a laser mark (no faux bold: the
    // photos match the fonts' own Regular weight)
    for (i = 0; i < L.length; i++) h += textEl(L[i], ox, ' stroke="' + ENG_FILL + '" stroke-linejoin="round" stroke-width="' +
      r2(Math.max(0.3, L[i].fs * 0.01)) + '" stroke-opacity=".45"');
    h += '</g></g></svg>';
    return h;
  }

  // ---------------------------------------------------------------- fonts
  // Layout never depends on the web fonts having loaded (built-in metric tables), but once they are in,
  // measurements switch to the real fonts (kerning included). onFontsReady(cb) fires after
  // LW Oregon and LW Brilliant have loaded (or failed), so the caller can re-render once.
  var fontCbs = [], fontsDone = false, fontsStarted = false;
  function onFontsReady(cb) {
    if (typeof cb === 'function') fontCbs.push(cb);
    if (fontsDone) { flush(); return; }
    if (!(win.document && document.fonts && document.fonts.load && win.Promise)) { fontsDone = true; flush(); return; }
    if (fontsStarted) return;
    fontsStarted = true;
    var p = [];
    try {
      p.push(document.fonts.load(FACE_SANS, 'BELLA 0123456789'));
      p.push(document.fonts.load(FACE_SCRIPT, 'Bella'));
      if (document.fonts.ready) p.push(document.fonts.ready);
    } catch (e) { }
    var done = function () { fontsDone = true; mcache = {}; flush(); };
    Promise.all(p).then(done, done);
  }
  function flush() { var cbs = fontCbs; fontCbs = []; for (var i = 0; i < cbs.length; i++) { try { cbs[i](); } catch (e) { } } }

  win.CSBone = {
    render: render,
    onFontsReady: onFontsReady,
    // builds the brushed-metal image once (~50 ms desktop); render() does it on first call if needed
    prepare: function () { return buildAssets(); },
    ratio: BW / BH,              // buckle width / height (4:3)
    viewBox: [VBW, VBH],
    path: PATH,
    version: '2.0.0',
    _layout: function (lines, cursive) { return layout(lines, cursive); }
  };
  // start font downloads early, and build the metal texture when the page goes idle
  try { onFontsReady(); } catch (e) { }
  try {
    if (win.requestIdleCallback) win.requestIdleCallback(function () { buildAssets(); }, { timeout: 2500 });
  } catch (e) { }
})(typeof window !== 'undefined' ? window : this);
